import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/7/14 下午4:18
 */ import { append, curry, equals, find, findIndex, ifElse, isEmpty, last, map, mergeRight, pick, slice, length, filter } from "ramda";
import { useNavigate } from "react-router-dom";
import { isArray } from "@/utils";
import { Tabs } from "antd";
export var ActionType = /*#__PURE__*/ function(ActionType) {
    ActionType["del"] = "DEL";
    ActionType["add"] = "ADD";
    ActionType["update"] = "UPDATE";
    ActionType["clear"] = "CLEAR";
    return ActionType;
}({});
function delKeepAlive(keepAliveList, param) {
    let { key, navigate, activeKey } = param;
    const index = findIndex((item)=>{
        if (item.path) {
            return equals(item.path, key);
        } else {
            return equals(item.key, key);
        }
    }, keepAliveList);
    if (equals(index, -1)) {
        return keepAliveList;
    }
    let pathname = "";
    if (keepAliveList.length > 1) {
        const data = keepAliveList[index];
        // 如果删除是  当前渲染     需要移动位置
        if (data && equals(data.key, activeKey)) {
            // 如果是最后一个 那么  跳转到上一个
            if (equals(index, keepAliveList.length - 1)) {
                const item = keepAliveList[index - 1];
                pathname = item.path ?? item.key;
            } else {
                // 跳转到最后一个
                const item = last(keepAliveList);
                pathname = (item === null || item === void 0 ? void 0 : item.path) ?? (item === null || item === void 0 ? void 0 : item.key) ?? "";
            }
        }
    }
    if (!isEmpty(pathname)) {
        navigate({
            pathname
        });
    }
    return filter((item)=>!equals(item.key, key), keepAliveList);
}
function addKeepAlive(state, matchRouteObj) {
    if (state.some((item)=>equals(item.key, matchRouteObj.key))) {
        return state;
    }
    return append(pick([
        "key",
        "title",
        "name",
        "path",
        "cache"
    ], matchRouteObj), length(state) >= 10 ? slice(1, length(state), state) : state);
}
const updateKeepAlive = curry((state, keepAlive)=>{
    const data = pick([
        "title",
        "path"
    ], keepAlive);
    return map((item)=>{
        if (item.path) {
            return equals(item.path, keepAlive.key) ? mergeRight(item, data) : item;
        }
        return equals(item.key, keepAlive.key) ? mergeRight(item, data) : item;
    }, state);
});
const updateKeepAliveList = curry((state, keepAlive)=>{
    return map((item)=>{
        const data = find((res)=>equals(res.key, item.key), keepAlive);
        if (data) {
            item = mergeRight(item, data ?? {});
        }
        return item;
    }, state);
});
export const reducer = (state, action)=>{
    switch(action.type){
        case "ADD":
            return addKeepAlive(state, action.payload);
        case "DEL":
            return delKeepAlive(state, action.payload);
        case "CLEAR":
            return [];
        case "UPDATE":
            return ifElse(isArray, updateKeepAliveList(state), updateKeepAlive(state))(action.payload);
        default:
            return state;
    }
};
function TagsView(param) {
    let { dispatch, tagsViewList, activeKey = "notActiveKey" } = param;
    const navigate = useNavigate();
    function hdChange(key) {
        if (key && !equals(key, "notActiveKey")) navigate({
            pathname: key
        });
    }
    function hdEdit(key) {
        if (key && !equals(key, "notActiveKey")) {
            dispatch({
                type: "DEL",
                payload: {
                    key,
                    navigate,
                    activeKey
                }
            });
        }
    }
    const closable = equals(1, length(tagsViewList));
    return /*#__PURE__*/ _jsx("div", {
        className: isEmpty(tagsViewList) ? "" : "tagsView",
        children: /*#__PURE__*/ _jsx(Tabs, {
            type: "editable-card",
            onChange: hdChange,
            className: "tagsView-tabs",
            hideAdd: true,
            activeKey: activeKey,
            onEdit: hdEdit,
            items: map((tag)=>{
                return {
                    key: tag.path ?? tag.key,
                    label: tag.title,
                    closable: !closable
                };
            }, tagsViewList)
        })
    });
}
export default TagsView;
